var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNewProjectAiAssistantBlue = function SvgIconNewProjectAiAssistantBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4276EE"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "m11.097 5.922 2.875 2.855m.854-5.538 1.933 1.917c.32.317.322.832.003 1.15L6.338 16.759a.825.825 0 0 1-1.164.003L3.24 14.844a.81.81 0 0 1-.003-1.15L13.662 3.241a.825.825 0 0 1 1.164-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M5.422 2.711a.083.083 0 0 1 .156 0l.719 1.943q.013.035.05.049l1.942.719a.083.083 0 0 1 0 .156l-1.943.719a.08.08 0 0 0-.049.05l-.719 1.942a.083.083 0 0 1-.156 0l-.719-1.943a.08.08 0 0 0-.05-.049l-1.942-.719a.083.083 0 0 1 0-.156l1.943-.719a.08.08 0 0 0 .049-.05zM14.422 12.211a.083.083 0 0 1 .156 0l.584 1.578q.013.035.05.05l1.577.583a.083.083 0 0 1 0 .156l-1.578.584a.08.08 0 0 0-.05.05l-.583 1.577a.083.083 0 0 1-.156 0l-.584-1.578a.08.08 0 0 0-.05-.05l-1.577-.583a.083.083 0 0 1 0-.156l1.578-.584a.08.08 0 0 0 .05-.05z"
  }))));
};
export default SvgIconNewProjectAiAssistantBlue;